// extracted by mini-css-extract-plugin
export default {"backdrop":"PreviewVideo_backdrop__7S1Km","z_index_100":"PreviewVideo_z_index_100__EfVPL","close_video_icon":"PreviewVideo_close_video_icon__sELi5"};